import React from 'react';
import WorkflowEdge from './WorkflowEdge';
import { MarkerType } from '@xyflow/react';

const WorkflowEdgeWrapper = (props: any) => {
  return <WorkflowEdge {...props} markerEnd="url(#react-flow__arrowclosed)" />;
};

export default WorkflowEdgeWrapper; 